import {weekdays, UserTime} from '../helpers.imba'

let fallback-price = 35

tag bootcamp-page
	css .header d:grid h:350px d:grid ai:center @900:flex-start bgc:teal4 bgc:$light-baby bgs:cover bgr:no-repeat
		h2 mt:0 @900:16
	css section w:100%
	css .container w:85% @md:80% mx:auto ta:center
		.text w:90% @sm:80% @md:90% @lg:80%
	css .plan mb:16 @900:0
		.content p:5 m:4 bd:1px solid $medium-grey rd:20px ta:center bgc:white h:min-content 
			.free, .pro, .cohort zi:4
			h4 fw:600 my:6
			svg zi:3
	css .pro bxs:0px 2px 40px 0px rgba(0,0,0,0.3) t:0 @900:-50px
	css .banner bgc:$lemony p:2 1 my:8 mx:auto w:200px rd:20px ta:center rotate:-3deg c:black fw:600
	css .usp mb:8 bgc:white p:2 4 rd:10px bxs:0px 1px 6px rgba(0, 0, 0, 0.15)
	css .strike td:line-through
	css .coupon font-style:italic fw:600 mb:4 rd:10px
	css .hl bgc:$light-lemony p:2 
	css section.meetings @before bg:none
	css section.meetings@before bg:none # TODO: Duplicate?
	css section.challenge@before bg:none
	css .approved of:visible
		>> stroke:white fill:$crab-cake 
	css .approved #shape filter:drop-shadow(0 0.2rem 0.25rem rgba(0, 0, 0, 0.2))
	css section.teacher-assistants@before bg:none
	css h2 fs:2rem

	def hydrate
		innerHTML = ''
		schedule!
		render!

	def unsticky-header
		window.flags.remove('mod-sticky-header')

	def sticky-header
		window.flags.add('mod-sticky-header')

	# def mount
	# 	window.addEventListener('quickchat:ready') do
	# 		if store.uid
	# 			Quickchat.set("uid", store.uid)

	def render
		<self>
			# header
			<section[bg:$light-baby pt:8]> <.container[ta:left pt:30 pb:10 w:85% @md:95% max-width:1240px]>
				<.header-content[d:grid gtc:100% @lg:auto auto g:4 ji:center]>
					<.left[max-width:610px pb:5 @md:20]>
						<p[fw:600 d:inline-block rotate:-3.3deg bgc:$lemony p:2.5 rd:full mb:0px]> "Frontend Bootcamp"
						<h1.bg2[my:4 fs:3rem] @intersect.out=sticky-header @intersect.in=unsticky-header> "Learn to code and build a career in tech"
						<p[fs:1.5rem]> "Get personalized coding guidance and resolve your queries in one-on-one mentor calls. Benefit from code reviews and access exclusive coding workshops."
				
					<[justify-self:center align-self:center w:100% d:grid]>
						<iframe[w:100% max-width:448px mx:auto rd:10px] width="448" height="252" src="https://www.youtube.com/embed/IOWy59bDuo8" title="Bootcamp intro video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen>
				<p[m:35px auto 32px]> "Enrollment to the bootcamp is closed at the moment."
				# <a href="https://meet.scrimba.com/team/scrimba-bootcamp/bootcamp-info-call" target="_blank"> " Schedule a call."

			# network
			<section.peers[bgc:$baby bgi:url('svg/discord-wallpaper.svg')]>  <.container[d:grid ja:center ai:center gtc:1fr @md:1fr 1fr gcg:0 @md:50px]>
				<div[ta:center as:center w:100%]>
					<img[w:min(90%,450px)] src="/static/art/bootcamp-discord.png" alt="messages from the Scrimba Bootcamp Discord channel">

				<.text[mb:8 ta:left]>
					<h2[mb:5 mt:5 @md:0 lh:1.17]> "Build your network in dedicated Discord channels"
					<p> "Join like-minded coders who are learning and building projects with the goal of getting hired as developers. We will connect you with study buddies for accountability check-ins and group projects."

			# 1-1 calls
			<section.teacher-assistants[bg:white]>  <.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr gcg:0 @md:50px]>
				<div[mb:8 as:center ta:center]>
					<img[pos:relative w:min(100%,380px) mt:40px rotate:-3deg] src="/static/art/1-1-calls.png" alt="Some of Scrimba's code reviewers." loading="lazy">

				<.text[ta:left as:center]>
					<h2[mb:6]> "Schedule calls with coding mentors"
					<p[mb:6]> "Get dedicated support with your projects and frontend development curriculum by scheduling calls with the Bootcamp mentors."
					<p[mb:6]> "You can also get help with optimizing your job search materials, like your CV, portfolio and LinkedIn profile."
					# <a.button[ mb:0 mt:10] href="#bootcamp"> "Join Now"

			# exclusive projects
			<section.reviews[bg:$light-baby]>  <.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr gcg:0 @md:50px]>
				<.text[mb:8 ta:left]>
					<h2[mb:5 mt:5 @md:0 lh:1.17]> "Build exclusive projects"
					<p[mt:3]> "Get access to Bootcamp-exclusive Solo Projects that will make your portfolio stand out."
					<p[mt:3]> "You'll also receive detailed reviews of these projects from our vetted team of experienced code reviewers."

				<div[ta:center as:center w:100%]>
					<img[pos:relative w:min(90%,450px) mt:40px rotate:-3deg] src="/static/photos/pages/bootcamp/exclusive-projects.png" alt="some of the exclusive projects available for Bootcamp students to build." loading="lazy">

			# code reviews
			<section.reviews[bg:$white]>  <.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr gcg:0 @md:50px pb:10]>
				<div[ta:center as:center w:100%]>
					<a href="/scrim/coa3b4c4593d6cfef437ca087" target="_blank">
						<img[pos:relative w:min(90%,550px) rotate:-3deg] src="/static/photos/pages/bootcamp/code-reviews.png" alt="a code review with a code reviewer's avatar." loading="lazy">

				<.text[mb:8 ta:left]>
					<h2[mb:5 mt:5 @md:0 lh:1.17]> "Get your code reviewed "
					<p> "An experienced coder will review all of your Solo Projects."
					<p[mt:3]> "Their feedback will help you find your coding skill gaps, build confidence, and ensure that you're progressing as fast as possible."
					<p[mt:3]> 
						"Check out an " 
						<a href="https://scrimba.com/scrim/coa3b4c4593d6cfef437ca087" target='_blank'> "example of a code review"
						" and "
						<a href="https://scrimba.com/articles/meet-your-code-reviewers/" target='_blank'> "meet your code reviewers here!"

			# Live sessions
			<section.meetings[c:white w:100vw bg:no-repeat url("/static/photos/weekly-meetup.png") bgs:cover bgc:$white pt:6]>
				<.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr gcg:0 @md:50px h:100% pb:28 mt:8]>
					<.text[mb:8 d:grid gtc:1fr ai:center ta:left as:center]>
						<h2[mb:5 mt:5 @md:0 lh:1.17]> "Live weekly sessions to help you stay on track"
						<p> "To help structure your week and guide you toward your goals, join our Virtual Meetups to check in with your progress and set goals as a group. Gain insight from special guests from the tech industry."
						<p[mt:3]> "We also have mentor-led workshops, where we dive deep into coding and career topics to supplement what you're learning on the Career Path."
						<p[pt:18px]> 
							<a[c:#fff fw:bold cursor:pointer] href="https://scrimba-bootcamp-schedule.super.site/" target="_blank"> "🗓️ View events calendar"

					<div[ta:center as:center w:100%]>
						<img[pos:relative w:min(90%,380px)] src="/static/art/bootcamp-meetings2.png" alt="calendar events for the Bootcamp weekly kick-off meeting and student support session." loading="lazy">
						# <svg src="svg/events.svg" loading='lazy' [w:85% max-width:370px]>
						" "

			# Group projects
			<section.reviews[bg:$white]>  <.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr gcg:0 @md:50px pb:10]>
				<div[ta:center as:center w:100%]>
					<a href="/scrim/coa3b4c4593d6cfef437ca087" target="_blank">
						<img[pos:relative w:min(87%,450px) rotate:-3deg] src="/static/art/bootcamp-group-projects.png" alt="a calendar event for the live Group Project kick-off." loading="lazy">

				<.text[mb:16 ta:left]>
					<h2[mb:5 mt:5 @md:0 lh:1.17]> "Collaborate on group projects"
					<p> "Gain valuable experience working on projects with a group using Git and GitHub."			
					<p[mt:3]> "You’ll work on different features of an app and get feedback on your code to prepare you for working on a professional development team."			
			
			# Job help
			<section.jobready[bg:$light-baby]>  <.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr gcg:0 @md:50px]>
				<.text[ta:left as:center]>
					<h2[mb:6]> "Get help landing your first job in the industry"
					<p[mb:6]> "When you begin your job search, we aim to increase your chances of getting hired by offering reviews of your portfolio, resume, and LinkedIn profile."
					<p[mb:6]> "We also offer interview practice periodically in the Coding Workshops or through scheduled 1-to-1 calls."

				<div[mb:8 as:center ta:center]>
					# <svg[w:85% max-width:370px] src="svg/events.svg">
					<svg src="svg/blob3.svg" [w:min(70%,250px) c:$medium-lavendar d@ltmd:none pos:absolute ml:6% t:0 rotate:1deg].shape>
					<img[pos:relative w:min(100%,380px) mt:40px] src="/static/art/bootcamp-skills.png" alt="Some skills you'lll learn in the Bootcamp: portfolio reviews, LinkedIn optimization, job interviews, job search strategy, networking, freelancing." loading="lazy">

			# curriculum
			<section.modern[bg:white]>  <.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr gcg:0 @md:50px pb:20]>
				<div[ta:left ml:12 as:center mt:10]>
					<svg src="svg/frontend-path.svg" loading='lazy' [w:85% max-width:370px h:auto]>
					<img[pos:absolute t:37px l:21px w:72% max-width:270px] src="/static/art/frontend-path.png" alt="Scrimba's Frontend Developer Career Path" loading="lazy"> 
					# Can we use the <cover-art> element here?
					# <svg src="svg/passed.svg" [pos:absolute t:10px l:0 w:140px zi:10]>

				<.text[ta:left as:center]>
					<h2[mb:5 mt:5 @md:0 lh:1.17]> "A modern, career-focused curriculum"
					<p> "The Bootcamp follows Scrimba’s { <a href="/learn/frontend"> "Frontend Developer Career Path" }. It takes an average of 4 to 6 months to complete and earn your certificate."
					<p[mt:3]> "{<a[c:$night td:underline] href="https://podcast.scrimba.com/"> "Hear stories" } about how students have succeeded with this curriculum."

				# <.pitch-cta[d:grid ac:baseline jc:center gcg:2rem gc:1 / 3]>
				# 	<a.button[ mb:0 mt: 6] href="#bootcamp"> "Join Now"
				# <a.button[ml:0 mr:6] href="https://scrimba.com/bootcamp?coupon=Bootcamp%20Sale%20-20%#bootcamp"> "Join now & save $150!"
					
			# Meet Micha
			<section.leader[bg:$light-lemony]>  
				<.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr gcg:0 @md:50px pb:20]>
					<.text[ta:left as:center]>
						<h2[mb:5 mt:5 @md:0 lh:1.17 ]> "Meet your Bootcamp mentor Micha"
						<p[mb:6]> "Micha Rodriguez has many years of experience as a teacher and mentor. She has been helping Scrimba students launch new careers in tech since the bootcamp’s inception, through code reviews, one to one mentoring, and live coding workshops."

					<div[mb:8 ta:right w:min(100%,280px)]>
						<img[pos:relative w:min(100%,280px)] src="/static/photos/pages/bootcamp/micha_avatar_round.png" alt="Scrimba Bootcamp Leader Micha Rodriguez." loading="lazy">
						<svg[w:50px h:auto pos:absolute t:65% r:0].approved src="svg/approved2.svg" loading='lazy'>
				
					# <div[p:relative gc: 1 / span 3 w:100% m:auto bg:white border-radius:10px p:1.35em 1.65em box-sizing:border-box  bxs:0px 3px 8px rgba(0, 0, 0, 0.15);]>
					# <img src="svg/blob.png" [display:none pos:absolute t:0 l:0 max-width:100% max-height:100% d@500:inline]>
					# <div[display:flex fld:column gap:15px ai:center jc:flex-start fld@500:row]>
					# 	<img[h:52px w:52px] src="svg/bootcamp-call-icon.png" alt="Chat bubble">
					# 	<p[ta:left max-width:100% max-width@500:40% fw:bold]> "Need some help to decide if this is right for you? Let’s have a chat."
					# 	<a[c:inherit ml:auto w:100% w@500:40% bd:3px solid #5035ff border-radius:5.61px fs:1.3rem p:0.45em 1em fs:1.125rem 10px text-decoration:none bg@hover:#5035FF c@hover:#fff] href="https://meet.scrimba.com/team/scrimba-bootcamp/bootcamp-info-call" target="_blank"> "Schedule Call"

			# Price comparison
			<section.price[bg:$light-baby]>  <.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr gcg:0 @md:50px pb:26]>
				<div[ta:center as:center @md:left w:min(90%, 500px)]>
					<img[pos:relative w:min(100%,500px)] src="/static/art/pricing-chart.png" alt="Scrimba Bootcamp pricing compared to three other coding bootcamps. Scrimba is by far the most affordable." loading="lazy">
				<.text[ta:left as:center pb:4 @md:0]>
					<h2[mb:5 mt:5 @md:0 lh:1.17]> "More affordable than the alternatives"
					<p> "The Scrimba Bootcamp is more flexible and affordable than most bootcamps, often priced at $10K-20k. You pay quarterly and progress according to your schedule."
					# <a.button[ mb:0 mt:10] href="#bootcamp"> "Join Now"
				
			# Buy with confidence
			<section[bgc:$light-lemony]>
				<.container>
					<h2[mb:10 fs:3rem]> "Buy with confidence"
					<.usps[d:grid gtc:1fr @sm:repeat(3,1fr) gcg:4rem mb:4]>
						<.usp[rotate:-0.5deg @md:-2.8deg]>
							<p> "✅"
							<p.bold[mb:4]> "14-day money-back guarantee"
							<p> "If the Bootcamp isn't for you, we'll refund you, no questions asked."
						<.usp[rotate:2.5deg @md:5deg]>
							<p> "✅"
							<p.bold[mb:4]> "Cancel any time"
							<p> "No notice period required, you’re free to disconnect."
						<.usp[rotate:-0.4deg @md:-1.7deg]>
							<p> "✅"
							<p.bold[mb:4]> "Keep your discount"
							<p> "Stays with you for the entirety of your subscription."
					# <p[m:24px auto 48px]> "Need help deciding if this is right for you?" 
					# 		<a href="https://meet.scrimba.com/team/scrimba-bootcamp/bootcamp-info-call" target="_blank"> " Schedule a call."

					# <.pitch[d:grid gaf:column mx:auto w:min(95%, 650px) ji:center @md:initial t:0px @md:50px]>
					# 	<svg src="svg/blob10.svg" [w:150vw @sm:600px c:$moss pos:absolute t:-85%].shape>
					# 	<.pitch-content[d:grid gaf:column w:min(95%, 520px) mx:auto t:20px]>
					# 		<svg[w:auto h:175px d:none @md:block] src="svg/peep-art-dude.svg" loading="lazy">
					# <.pitch-cta[d:grid gtc:1fr grg:1rem]>
					# <.pitch-cta[d:grid ac:baseline jc:center gcg:2rem b:20px]>
					# 	<a.button[mx:auto mb:4] href="#bootcamp"> "Join Now"
					# 	# <a.button[mx:auto mb:4] href="https://scrimba.com/bootcamp?coupon=Bootcamp%20Sale%20-20%#bootcamp"> "Save $150"
					# 	<p[ta:center]>
					# 		<b> "$750 for 3 months, includes everything in the Pro plan."
					# 		# <span style="font-weight:bold">
					# 		# 	<span style="text-decoration: line-through;"> "$750"
					# 		# 	" $600 for 3 months"
					# 		# "- sale on until March 6th!"
					# <svg src="svg/peep-buns-girl.svg" [d:none @md:block h:135px b:-25px d:none @md:initial] loading="lazy">
			
			# Reviews
			<section.jobready[bg:$light-baby]>
				<div[mb:16 as:center ta:center]>
					<h2[mt:12 mb:8 ta:center]> "What people are saying"
					<script type="text/javascript" src="https://testimonial.to/js/iframeResizer.min.js">
					<iframe id="testimonialto-scrimba-2-light" src="https://embed-v2.testimonial.to/w/scrimba-2?theme=light&card=large&loadMore=on&initialCount=20&randomize=on&hideDate=on" frameborder="0" scrolling="no" width="100%">
					<script type="text/javascript"> 'iFrameResize({log: false, checkOrigin: false}, "#testimonialto-scrimba-2-light")'

			# FAQ
			<section.faq[bg:$white pt:12]> <.container[d:grid]>
				<h2.title[mb:20 ta:left]> 
					<span[fw:600 fs:5xl mx:5px]> "F "
					<span[d:none @sm:initial fs:2xl mx:5px]> " to the "
					<span[fw:600 fs:5xl mx:5px]> " A " 
					<span[fs:2xl mr:5px d:none @sm:initial]> " to the "
					<span[fw:600 fs:5xl mx:5px]> " Q"
					<img[b:-55px w:144px d:none @350:initial].peep src="/static/art/peep-oracle.svg" alt="one-eyed person cartoon sitting with leg raised on one knee." loading="lazy">
				
				<.faqs[d:grid gtc:33% 33% 33% gap:3rem ta:left]>
				# line above: gtc:1fr not working - why?
					
					<.faq>
						<p.bold[mb:4]> 
							"I can't find how to join the bootcamp" 
						<p> "The bootcamp is currently not accepting new enrollments."

					<.faq>
						<p.bold[mb:4]> 
							"Do Bootcampers have to study the " 
							<a href="https://scrimba.com/learn/frontend/"> "Career Path"
							"?"
						<p> "Yes. The Scrimba Bootcamp follows the Frontend Developer Career Path. The sessions focus on core areas of the Career Path and the Solo Projects within it."

					<.faq>
						<p.bold[mb:4]> "What does the Bootcamp include?"
						<p> "As well as full access to Scrimba Pro, the Bootcamp also includes Solo Project code reviews, a dedicated study group, and weekly teacher-led group sessions. If you are already subscribed to Scrimba Pro, the amount you paid for your subscription will be subtracted from the total cost when you sign up for the Bootcamp."

					<.faq>
						<p.bold[mb:4]> 
							"What's the difference between the Bootcamp and the "
							<a href="https://scrimba.com/learn/frontend/"> "Career Path"
							"?"
						<p> "The Bootcamp follows the Career Path curriculum, but also offers weekly teacher-led sessions, support from teaching assistants, exclusive Solo Projects, and detailed code reviews."
					<.faq>
						<p.bold[mb:4]> "I've already started the Frontend Career Path. Can I still join the Bootcamp?"
						<p> "Absolutely! The Bootcamp code reviews and weekly support will be valuable in your learning, no matter where you are in the curriculum. You can also submit any Solo Projects you have already built for review."

					<.faq>
						<p.bold[mb:4]> "What happens if I need longer than 3 months to complete the Bootcamp?"
						<p> "No problem! You can remain enrolled on the Bootcamp and keep the quarterly subscription price you signed up with, even if the price for new students has increased."

					<.faq>
						<p.bold[mb:4]> "When does the Bootcamp start?"
						<p> "As soon as you sign up! You can start requesting code reviews for your Solo Projects immediately. You'll join your first group session the following Monday."

					<.faq>
						<p.bold[mb:4]> "How do code reviews work?"
						<p> "The Bootcamp provides a code review by an experienced coder for all your Solo Projects, plus a follow-up review to cover any revisions or outstanding questions."

					<.faq>
						<p.bold[mb:4]> "What is the turnaround time for a code review?"
						<p> "You'll receive each review within 24 hours of submitting your project."
					
					<.faq>
						<p.bold[mb:4]> "Is this a cohort program?"
						<p> 
							"It's not. Instead, you progress through the "
							<a href="https://scrimba.com/learn/frontend/"> "Frontend Developer Career Path" 
							" at your own pace while attending weekly group sessions."

					<.faq>
						<p.bold[mb:4]> "I have another question about the Bootcamp - how can I get in touch?"
						<p> "Send us a message at "
							<a[cursor:pointer] href="mailto: bootcamp@scrimba.com?subject=Bootcamp%20Enquiry%20"> "bootcamp@scrimba.com"
							". We are always happy to help! 😃"

					<.pitch-cta[d:grid ac:baseline jc:center gcg:2rem gc:1 / 4]>
					# <a.button[mx:auto mb:0] href="#bootcamp"> "Join Now"
					# <a.button[ml:0 mr:6] href="https://scrimba.com/bootcamp?coupon=Bootcamp%20Sale%20-20%#bootcamp"> "Join now & save $150!"


